import { Component, computed, input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FeatherPipe } from '../../../core/pipes/feather.pipe';
import { FeatherIconNames } from 'feather-icons';

@Component({
  selector: 'app-value-card',
  standalone: true,
  imports: [CommonModule, FeatherPipe, DecimalPipe],
  templateUrl: './value-card.component.html',
  styleUrl: './value-card.component.scss'
})
export class ValueCardComponent {
  title = input<string>('');
  subtitle = input<string>('');
  color = input<'primary' | 'info' | 'success' | 'warning' | 'danger' | 'neutral'>('primary');
  icon = input<FeatherIconNames | null>(null);
  imageUrl = input<string | null>(null);
  iconSize = input<number>(24);

  value = input<string | number | null>(null);
  decimalPlaces = input<number | null>(null);
  prefix = input<string>('');
  suffix = input<string>('');

  isNumber = computed(() => typeof this.value() === 'number');

  decimalFormat = computed(() => {
    const dp = this.decimalPlaces();
    if (dp === null || dp === undefined) return undefined;
    return `1.${dp}-${dp}`;
  });
}
